import { render, staticRenderFns } from "./ReleaseDetailsHeader.vue?vue&type=template&id=723e9145&scoped=true"
import script from "./ReleaseDetailsHeader.vue?vue&type=script&lang=js"
export * from "./ReleaseDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./ReleaseDetailsHeader.vue?vue&type=style&index=0&id=723e9145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723e9145",
  null
  
)

export default component.exports